export default "__VITE_ASSET__BZrWiziV__"